import React from 'react';
import PropTypes from 'prop-types';

import GraphConstants from 'app/shared/constants/GraphConstants';

import Text from '@zg-rentals/multibrand-ui/lib/Text';

import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
} from 'recharts';

import './style.scss';

const propTypes = {
    layout: PropTypes.string,
};

const defaultProps = {
    layout: 'horizontal',
};

const BasicBarChart = ({
    layout,
    title,
    data,
    dataValueKey = '',
    dataLabelKey = '',
    showXAxis = true,
    showYAxis = true,
}) => {
    let currentXAxis = <XAxis dataKey="name" type="category" />;
    let currentYAxis = <YAxis type="number" />;
    if (layout !== 'horizontal') {
        currentXAxis = <XAxis type="number" tick={showXAxis} />;
        currentYAxis = <YAxis dataKey={dataLabelKey} tick={showYAxis} type="category" />;
    }

    return (
        <div className="BasicBarChart">
            {title && <Text type="h5" emphasize={true}>{title}</Text>}
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data} layout={layout}>
                    {currentYAxis}
                    {currentXAxis}
                    <Tooltip />
                    <Bar dataKey={dataValueKey} fill={GraphConstants.COLORS.zillow.primary} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

BasicBarChart.propTypes = propTypes;
BasicBarChart.defaultProps = defaultProps;

export default BasicBarChart;
